import { LitElement, html, css } from './-global.min.js'

class HHVideoPlayStateControl extends LitElement {
  static properties = {
    isPlaying: {
      type: Boolean,
      state: true,
      reflect: true,
    }
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.isPlaying = true
    this.hideControls = this.getAttribute('hide-controls')
    this.updateVideoStates()
  }

  toggleVideoPlaying() {
    this.isPlaying = !this.isPlaying
    this.updateVideoStates()
  }

  updateVideoStates() {
    this.querySelectorAll('video').forEach((video) =>
      this.isPlaying ? video.play() : video.pause()
    )
  }

  static styles = css`
    :host {
      width: 100%;
    }

    :host .hh-video-play-state-control {
      position: relative;
      width: 100%;
      height: auto;
    }

    ::slotted(video) {
      width: 100%;
      object-fit: cover;
      height: auto;
    }

    :host([full-height]) .hh-video-play-state-control {
      height: 100%;
    }

    :host([full-height]) ::slotted(video) {
      height: 100%;
    }

    .hh-video-play-state-control__controls-container {
      position: absolute;
      display: flex;
      column-gap: 1.6rem;
      bottom: 10px;
      right: 10px;
      z-index: 5;
    }

    :host button {
      padding: 0;
      border: none;
      background: none;
      color: inherit;
      cursor: pointer;
      color: var(--text-color);
      opacity: 0.5;
    }
  `

  get pauseIcon() {
    return html`
      <div class="hh-banner__pause-icon" aria-hidden="true">
        <svg
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.661513 23.9988H7.1395C7.50546 23.9988 7.80098 23.719 7.80098 23.3726L7.80236 1.60468C7.80236 1.25825 7.50683 0.978516 7.14088 0.978516H0.66148C0.295511 0.978516 0 1.25826 0 1.60468V23.374C0 23.7191 0.296904 23.9988 0.66148 23.9988L0.661513 23.9988ZM1.32437 2.23084H6.47947V22.7465L1.32437 22.7452V2.23084Z"
            fill="currentColor"
          />
          <path
            d="M12.1992 1.60468V23.374C12.1992 23.7204 12.4947 24.0001 12.8607 24.0001H19.3387C19.7047 24.0001 20.0002 23.7204 20.0002 23.374L20.0015 1.60468C20.0015 1.25825 19.706 0.978516 19.3401 0.978516H12.8621C12.4961 0.978516 12.1992 1.25826 12.1992 1.60468ZM13.5222 2.23084H18.6759V22.7465L13.5222 22.7452V2.23084Z"
            fill="currentColor"
          />
        </svg>
      </div>
    `
  }

  get playIcon() {
    return html`
      <div class="hh-banner__play-icon" aria-hidden="true">
        <svg
          width="19"
          height="21"
          viewBox="0 0 19 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.04431 19.1119C2.21099 19.5881 1.17414 18.9864 1.17414 18.0266L1.17413 2.06222C1.17413 1.10244 2.21099 0.500733 3.04431 0.976916L17.0132 8.95913C17.8529 9.43899 17.8529 10.6499 17.0132 11.1297L3.04431 19.1119Z"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
      </div>
    `
  }

  togglePlayTemplate() {
    return html`
      ${this.hideControls ? '' : html`
        <button
          type="button"
          class="hh-banner-video__controls-btn"
          aria-label="Toggle video"
          @click="${this.toggleVideoPlaying}"
          data-state="${this.isPlaying ? 'playing' : 'paused'}"
      >
          ${this.isPlaying ? this.pauseIcon : this.playIcon}
        </button>
      `}
    `
  }

  render() {
    return html`
      <div class="hh-video-play-state-control">
        <slot></slot>
        <div class="hh-video-play-state-control__controls-container">
          ${this.togglePlayTemplate()}
        </div>
      </div>
    `
  }
}

if (typeof customElements.get('video-play-state-control') === 'undefined') {
  customElements.define('video-play-state-control', HHVideoPlayStateControl)
}
